import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import FlagAnimation from './FlagAnimation';
import './Hero.css';

const stats = [
  { icon: '⚙', value: '976cc', label: 'ENGINE' },
  { icon: '⊙', value: '92 HP', label: 'PERFORMANCE' },
  { icon: '◫', value: '300kg', label: 'PAYLOAD CAPACITY' },
  { icon: '△', value: 'Delphi EFI', label: 'PRECISION ENGINEERING' },
];

function Hero() {
  const headingRef = useRef(null);
  const subRef = useRef(null);
  const actionsRef = useRef(null);
  const flagWrapperRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: 'power4.out' } });

    tl.fromTo(headingRef.current,
      { y: 80, opacity: 0 },
      { y: 0, opacity: 1, duration: 1.2, delay: 0.5 }
    )
    .fromTo(subRef.current,
      { y: 40, opacity: 0 },
      { y: 0, opacity: 1, duration: 1 },
      '-=0.8'
    )
    .fromTo(actionsRef.current,
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8 },
      '-=0.6'
    )
    .fromTo(flagWrapperRef.current,
      { scale: 0.7, opacity: 0, x: 100, rotation: 5 },
      { scale: 1, opacity: 1, x: 0, rotation: 0, duration: 1.5, ease: 'back.out(1.2)' },
      '-=0.8'
    );
  }, []);

  return (
    <section className="hero">
      <div
        className="hero__bg"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/atv-hero.png)` }}
      >
        <div className="hero__overlay" />
        <div className="hero__container">
          <div className="hero__content">
            <h1 className="hero__heading" ref={headingRef}>
              Engineered<br />
              For Terrain.<br />
              Built For Every<br />
              Adventure.
            </h1>
            <p className="hero__sub" ref={subRef}>
              High-performance ATVs crafted for power,<br />
              durability, and precision across every terrain.
            </p>
            <div className="hero__actions" ref={actionsRef}>
              <Link to="/narsimha" className="hero__btn hero__btn--primary">
                Explore Models
                <svg className="hero__btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M4 12h15M13 6l6 6-6 6" />
                </svg>
              </Link>
              <Link to="/test-ride" className="hero__btn hero__btn--outline">
                Book Test Ride
                <svg className="hero__btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M4 12h15M13 6l6 6-6 6" />
                </svg>
              </Link>
            </div>
          </div>

          {/* Waving flag next to the hero content */}
          <div className="hero__flag-section" ref={flagWrapperRef}>
            <FlagAnimation width={380} height={240} />
          </div>
        </div>
      </div>

      <div className="hero__stats">
        {stats.map((s, i) => (
          <React.Fragment key={s.label}>
            <div className="hero__stat">
              <span className="hero__stat-icon">{s.icon}</span>
              <div className="hero__stat-text">
                <span className="hero__stat-value">{s.value}</span>
                <span className="hero__stat-label">{s.label}</span>
              </div>
            </div>
            {i < stats.length - 1 && <div className="hero__stat-divider" />}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}

export default Hero;

